import * as yup from 'yup';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';

export const usePasswordsPolicyFormValidation = () => {
  const { formatMessage } = useLocale();

  const schema = yup.object().shape({
    passwordRenewalDays: yup
      .number()
      .transform((val, orig) => (orig === '' ? undefined : val))
      .min(0)
      .max(365, formatMessage({ id: AppMessages['definitions.passwordPolicy.numberOfDays.validation.max'] })),
    minimumPasswordLength: yup
      .number()
      .required(formatMessage({ id: AppMessages['common.validation.required'] }))
      .typeError(formatMessage({ id: AppMessages['common.validation.required'] }))
      .min(8, formatMessage({ id: AppMessages['definitions.passwordPolicy.minLength.validation.max'] }))
      .max(30, formatMessage({ id: AppMessages['definitions.passwordPolicy.minLength.validation.max'] })),
  });

  return { schema };
};
